/* eslint-disable react/prop-types */
import React from 'react';

export default function PartenaireSubBlock({ number, title, children }) {
  return (
    <div className="bg-white rounded-md p-3 flex gap-1 flex-col">
      <div className="flex gap-2 flex-row">
        <div className="h-8 w-8 bg-beige-hellio-2 text-bleu-hellio text-sm/8 text-center rounded-2xl">
          {number}
        </div>
        <h4 className="flex-1 text-bleu-hellio text-sm/8 font-medium">
          {title}
        </h4>
      </div>
      <div className="text-gris-hellio text-xs/5">{children}</div>
    </div>
  );
}
